module.exports = __webpack_public_path__ + "static/appointer-meet-chat-e4348114b988d626eecfb1697b2b3038.mp4";